"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var services_1 = require("../../services");
var router_1 = require("@angular/router");
var constants_1 = require("../../constants");
var ModalComponent = (function () {
    function ModalComponent(activatedRoute, router, eventService, localizationService, progressService, userService) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventService = eventService;
        this.localizationService = localizationService;
        this.progressService = progressService;
        this.userService = userService;
        this.langsLinks = [];
        this.interfaceLocals = {};
        this.stateHiddenSpinner = true;
        this.version = constants_1.VERSION;
        this.copyright = this.localizationService.copyright;
        this.langsObject = this.localizationService.langsObject;
        this.langsArray = this.localizationService.langsArray;
        this.loadingText = this.localizationService.loadingText;
    }
    ModalComponent.prototype.ngOnInit = function () {
        this.routerSubscribe();
        this.subscribeOnEvents();
    };
    ModalComponent.prototype.ngOnDestroy = function () {
        this.unSubscribeFromEvents();
    };
    ModalComponent.prototype.subscribeOnEvents = function () {
        var _this = this;
        this.subscriptioShowModalEvent = this.eventService.subscribe('showModalComponent', function () { return _this.showModal(); });
        this.subscriptionHideModalEvent = this.eventService.subscribe('hideModals', function () { return _this.hideModal(); });
    };
    ModalComponent.prototype.unSubscribeFromEvents = function () {
        this.subscriptioShowModalEvent.unsubscribe();
        this.subscriptionRouter.unsubscribe();
        this.subscriptionHideModalEvent.unsubscribe();
    };
    ModalComponent.prototype.routerSubscribe = function () {
        var _this = this;
        this.subscriptionRouter = this.activatedRoute.params.subscribe(function (data) {
            if (_this.localizationService.currentLang !== data.lang) {
                _this.showSpinner();
                _this.localizationService.getLocals();
            }
            _this.renderInterfaceLocals();
        });
    };
    ModalComponent.prototype.resetProgress = function () {
        var rootUrl = this.localizationService.getRootUrl();
        this.progressService.resetProgress();
        this.userService.resetProgress();
        this.eventService.fire('progressSynced');
        this.router.navigate([rootUrl]);
        this.pullRightContent();
    };
    ModalComponent.prototype.hideModal = function () {
        this.stateActiveModalComponent = false;
        this.pullRightContent();
        this.eventService.fire('showScroll');
    };
    ModalComponent.prototype.renderInterfaceLocals = function () {
        var _this = this;
        this.localizationService.interfaceLocals
            .then(function (locals) {
            _this.interfaceLocals = locals;
            _this.currentLang = _this.localizationService.currentLang;
            _this.hideSpinner();
        });
    };
    ModalComponent.prototype.showSpinner = function () {
        this.stateHiddenSpinner = false;
    };
    ModalComponent.prototype.hideSpinner = function () {
        this.stateHiddenSpinner = true;
    };
    ModalComponent.prototype.showModal = function () {
        this.stateActiveModalComponent = true;
        this.setRouterLinks();
    };
    ModalComponent.prototype.pushRightContentWithLangs = function () {
        this.setRouterLinks();
        this.enableStateRightContent();
        this.enableStateActiveLangs();
    };
    ModalComponent.prototype.pushRightContent = function () {
        this.stateActiveReset = true;
        this.enableStateRightContent();
        this.disableStateActiveLangs();
    };
    ModalComponent.prototype.pullRightContent = function () {
        this.stateActiveReset = false;
        this.disableStateRightContent();
        this.hideBackButton();
    };
    ModalComponent.prototype.enableStateRightContent = function () {
        this.stateRightContent = true;
    };
    ModalComponent.prototype.disableStateRightContent = function () {
        this.stateRightContent = false;
    };
    ModalComponent.prototype.enableStateActiveLangs = function () {
        this.stateActiveLangs = true;
        this.showBackButton();
    };
    ModalComponent.prototype.disableStateActiveLangs = function () {
        this.stateActiveLangs = false;
    };
    ModalComponent.prototype.showModalHelpComponent = function () {
        this.eventService.fire('showModalHelp');
    };
    ModalComponent.prototype.setRouterLinks = function () {
        this.langsLinks = this.localizationService.setRouterLinks();
    };
    ModalComponent.prototype.showBackButton = function () {
        this.stateActiveBack = true;
    };
    ModalComponent.prototype.hideBackButton = function () {
        this.stateActiveBack = false;
    };
    return ModalComponent;
}());
ModalComponent = __decorate([
    core_1.Component({
        selector: 'modal-component',
        template: require('./modal.component.pug'),
        styles: [require('./modal.component.scss')]
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        router_1.Router,
        services_1.EventService,
        services_1.LocalizationService,
        services_1.ProgressService,
        services_1.UserService])
], ModalComponent);
exports.ModalComponent = ModalComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/modal/modal.component.ts
// module id = 250
// module chunks = 0